module.exports = __webpack_public_path__ + "img/avatar.9261bee9.svg";